import {Component} from '@angular/core';
import {BreadcrumbComponent} from '@pes/ui';

@Component({
    selector: 'lbpa-breadcrumb',
    templateUrl: './lbpa-breadcrumb.component.html'
})
export class LbpaBreadcrumbComponent extends BreadcrumbComponent {

    constructor() {
        super();
    }

}



// WEBPACK FOOTER //
// ./src/app/component/lbpa-breadcrumb/lbpa-breadcrumb.component.ts